import { carrierSubmissionFieldsConfig } from '@common/config';
import { UseFormReturn } from 'react-hook-form';
import { CarrierSubmissionFormValues } from './useCarrierSubmissionForm';

function isValueFilled(value: unknown): boolean {
  if (value == null) {
    return false;
  }
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return true;
}

function areRequiredFieldsFilled(values: Record<string, unknown>): boolean {
  return Object.entries(carrierSubmissionFieldsConfig).every(([key, config]) => {
    if (!config.isRequired) {
      return true;
    }

    const value = values[key];

    if (config.nestedRequiredFields) {
      if (value == null || typeof value !== 'object') {
        return false;
      }
      const nested = value as Record<string, unknown>;
      return config.nestedRequiredFields.every((nestedKey) => isValueFilled(nested[nestedKey]));
    }

    return isValueFilled(value);
  });
}

export function useAllFieldsFilled(methods: UseFormReturn<CarrierSubmissionFormValues>): boolean {
  const values = methods.watch();
  return areRequiredFieldsFilled(values as Record<string, unknown>) && methods.formState.isValid;
}
